import React, { useContext } from 'react';
import './RecentBlogs.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaEye, FaCalendarAlt } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { HomeContext } from '../../Context/HomeContext';
import Loader from '../Loader';

const RecentBlogs = () => {
    const { homeData, loading } = useContext(HomeContext);
    const blogs = homeData?.recentBlogs || [];

    const featuredBlog = blogs[0];
    const sideBlogs = blogs.slice(1, 6);

    if (loading || blogs.length === 0) {
        return <Loader text="Loading..." />;
    }
    

    return (
        <div className="container bg-black text-white py-4">
            <div className="row g-4">
                {/* LEFT: Main Feature */}
                <div className="col-lg-8">
                    <NavLink to={`/blog/${featuredBlog.slug}`} className="text-decoration-none text-white">
                        <div className="bg-dark rounded p-3">
                            <img
                                src={`https://api.funfillia.com/${featuredBlog.image_1150x900}`}
                                alt={featuredBlog.title}
                                className="rounded w-100 mb-3 feature-image-left"
                            />
                            <h2 className="feature-title mb-2">{featuredBlog.title}</h2>
                            <div className="d-flex align-items-center gap-3 small ">
                                <span>
                                    <FaCalendarAlt className="me-1" />
                                    {new Date(featuredBlog.published_at).toLocaleDateString()} &nbsp;    <FaEye className="me-1" />
                                    {featuredBlog.views_count}
                                </span>
                               
                            </div>
                        </div>
                    </NavLink>
                </div>

                {/* RIGHT: Sidebar Cards */}
                {/* RIGHT: Sidebar Cards */}
                <div className="col-lg-4">
                    <div className="d-flex flex-column ">
                        {sideBlogs.map((item, index) => (
                            <NavLink to={`/blog/${item.slug}`} key={index} className="text-decoration-none">
                                <div className="d-flex rounded sidebar-item1 bg-dark p-2">
                                    <img
                                        src={`https://api.funfillia.com/${item.image_500x500}`}
                                        className="rounded me-3"
                                        width="60"
                                        height="60"
                                        alt={item.title}
                                        title= {item.title}
                                    />
                                    <div className="small text-light">
                                        <p className="mb-1 fw-semibold">{item.title}</p>
                                        <div className=" small d-flex flex-column">
                                            <span><FaCalendarAlt className="me-1" />{new Date(item.published_at).toLocaleDateString()}  &nbsp; <FaEye className="me-1" />{item.views_count}</span>
                                          
                                        </div>
                                    </div>
                                </div>
                            </NavLink>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default RecentBlogs;
